'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('user-directory', {
      url: '/user/directory',
      template: '<user-directory></user-directory>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/user/user-directory.routes.js